module.exports = __webpack_public_path__ + "static/media/hiw_wrapper.fe13e227.png";